import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager, Clipboard, Keyboard,

} from "react-native"
import {typeExport} from "../../../../redux/store/type";
import {moderateScale} from "../../../../tools/Scaling";
import * as Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
import i18n from "../../../../I18n/i18n";
import {Tools} from "../../../../tools/Tools";
import HMIcon from "../../../../customviews/HMIcon";
import store from "../../../../redux/store";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import {callWebservice} from "../enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen";
import HMAlert from "../../../../customviews/HMAlert";
import PathFile from "../../../../assets/PathFile";
import DeviceInfo from "../../../../importCalss/DeviceInfo";
import RNOtpVerify from "react-native-otp-verify";

let content = null;
export default class EnterCodeSatiaScreen extends Component {

    constructor(props) {
        super(props);
        content = this;
        let {message, time} = props.route.params;
        this.state = {
            code: '',
            time: time ? time : 120,
            seconds: 120,
            count: 120,
            countCall: 0,
        }
    }


    componentWillReceiveProps(props) {


    }


///////// SMS ///////
    // Actions


    startListeningForOtp = () =>
        RNOtpVerify.getOtp()
            .then(p => RNOtpVerify.addListener(this.otpHandler))
            .catch(p => console.log(p));

    otpHandler = (message: string) => {
        try {
            //  console.log("message1", message)
            const otp = /(\d{4})/g.exec(message)[1];

            this.setState({code: otp});
            RNOtpVerify.removeListener();
            Keyboard.dismiss();
            this.getData();
        }
        catch (e) {
            console.log(e)
        }

    }

/////////
    componentDidMount() {

        this.retryTime();
        if (Platform.OS === "android") {

            this.startListeningForOtp()
        }

        if (Platform.OS === "web") {

            if ("OTPCredential" in window) {
                const ac = new AbortController();

                navigator.credentials.get({
                    otp: {transport: ["sms"]},
                    signal: ac.signal
                })
                    .then((otp) => {

                        this.setState({code: otp.code});
                        ac.abort();
                    })
                    .catch((err) => {
                        ac.abort();
                        console.log(err);
                    });
            }
        }

        //     BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    retryTime() {


        if (content.timeout) {
            clearInterval(content.timeout);
        }
        content.setState({
                seconds: content.state.time,
                countCall: content.state.countCall + 1,
            },
            () => {
                content.timeout = setInterval(() => {
                    if (content.state.seconds < 1) {

                        // content.setState({
                        //         countCall: 1,
                        //     },
                        // )
                        /*    this.setState({

                            })*/
                        //   this.props.navigation.pop();
                    }
                    else
                        content.setState({
                            seconds: content.state.seconds - 1
                        })
                }, 1000);
            }
        )

    }


    checkCode(text) {
        if (text == null) {

            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkCode'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        }
        else {
            if (text.length < 3) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.WrongCodeEntered'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert(i18n.t('constant.WrongCodeEntered'))
            } else {
                //   this.loadingButton.showLoading(true);
                this.setState({
                        code: text,
                    }
                    ,
                    () => {
                        this.getData(text)
                    }
                );

            }
        }
    }

    getData() {

        if (this.props.DataSplashScreen.Connection) {
            let paramss = {

                "lang": i18n.locale,
                "username": Tools.persianToEnglish(this.props.route.params.mobile),
                "password": Tools.persianToEnglish(this.state.code),
                "token_fb": this.props.DataSplashScreen.token_fb,
            };

            this.props.callService(
                //  content.state.indexSelectType === 0 ? urlGetLoginEnterPhoneSatiaScreen : typeExport._baseUrlSainaShahrdar,
                // typeExport._baseUrlSatia + "user/login",
                typeExport._baseUrlSatia + "user/login",
                paramss,
                typeExport.TypegetDataEnterCodeSatiaScreen,
                "POST"
            );

        } else
            this.props.callServiceError("offline")


    }

    checkMobile(text) {


        text = Tools.persianToEnglish(text)

        const reg = /^([0]|| [98])?09\d{9}$/;
        if (reg.test(text) === false) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkMobile'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        } else {
            this.getData()
            /*  if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length <= 3) {
                  HMAlert(
                      i18n.t('constant.message'),
                      i18n.t('constant.checkPassword'),
                      [
                          // {text: 'Ask me later', onPress: () => {}},
                          // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                          {text: i18n.t('constant.ok'), onPress: () => {}},
                      ],
                      {cancelable: true}
                  )
                  //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

              } else {
                  //  this.loadingButton.showLoading(true);
                  this.setState({
                          // mobile: text,
                      }
                      ,
                      () => {
                          this.getData()
                      }
                  );

              }*/

        }

    }

    componentWillUnmount() {

        if (this.timeout) {
            clearInterval(this.timeout);
        }
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {code} = this.state;
        let {message, Email, Phone, mobile} = this.props.route.params;


        let checkCallCode = !(this.state.seconds < 1 || (this.state.countCall <= 1));

        return (
            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>
                <View style={{flex: 1,}}>

                    <View
                        style={{
                            flex: .4,
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: Colors.colorPrimary
                        }}
                    >
                        {/* <HMTextView
                            style={{
                                color: "#fff",
                                fontSize: moderateScale(34),
                                //fontSize:moderateScale(16)
                            }}
                            text={i18n.t('appName')}
                            type={"bold"}
                        />*/}
                        <Image

                            //resizeMode={"stretch"}
                            style={{
                                width: moderateScale(80),
                                height: moderateScale(42),

                                //position: 'absolute',
                                //borderRadius: 50),
                                //     backgroundColor: Colors.white


                            }}
                            // source={require('../../../assets/img/logo.png')}
                            source={PathFile.image.name_satia}
                            //source={{uri: "https://painrelief-blog.org/wp-content/uploads/2019/07/5d2233166143e.jpg"}}
                        />

                    </View>

                    <View style={{
                        flex: .6,
                        padding: moderateScale(14),
                        //backgroundColor:"#ee0038"
                    }}>
                        {/*             <HMTextView
                  style={{
                      //fontSize:moderateScale(16)
                  }}
                  text={"ساتیا"}
                  type={"bold"}
              />*/}

                        <HMTextInput
                         //   _ref={(ref) => this.valueRef = ref}
                            onRef={(ref) => { this.valueRef = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.getConstants().isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            //  title={'constant.descCode'}
                            title={message}
                            // noLangTitle
                            placeholder={i18n.t('constant.ActivationCode')}

                            //lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("code", text)}
                            onSubmitEditing={() => {
                                this.checkCode(this.state.code)
                            }}
                            // onPressClear={() => this.onChangeText("code", null)}
                            onPressClear={() => {
                                this.onChangeText("code", null)
                                this.valueRef.clear()
                            }}
                            value={code}
                            keyboardType="numeric"
                        />

                        <View style={{
                            width: '100%',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            marginVertical: moderateScale(6),
                        }}>


                            {/*<HMTextView text={"زمان باقی مانده : " + Tools.getTimeStringM(this.state.seconds)}*/}
                            {/*type="bold"*/}
                            {/*style={{*/}
                            {/*alignSelf: "center",*/}
                            {/*color: Colors.colorDark,*/}
                            {/*fontSize: moderateScale(13),*/}
                            {/*textAlign: 'center',*/}
                            {/*// backgroundColor:"#ee4699"*/}

                            {/*}}/>*/}
                            <View style={{flex: 1}}/>
                            {/*<TouchableOpacity*/}
                            {/*style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center',    height: moderateScale(40),marginHorizontal:moderateScale(8)}}*/}
                            {/*onPress={() => {*/}
                            {/*let paramss = {*/}
                            {/*"lang": i18n.locale,*/}
                            {/*"mobile": this.props.route.params.mobile,*/}
                            {/*};*/}


                            {/*store.dispatch(callWebservice(*/}
                            {/*null,*/}
                            {/*// typeExport._baseUrlSatia + "user/sendcode",*/}
                            {/*typeExport._baseUrlSatia + "user/sendcode",*/}
                            {/*paramss,*/}
                            {/*typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,*/}
                            {/*"POST",*/}
                            {/*this.state,*/}
                            {/*this.retryTime*/}
                            {/*))*/}

                            {/*}}*/}
                            {/*disabled={this.state.seconds >= 1}*/}
                            {/*>*/}
                            {/*<HMTextView text={"ارسال مجدد"} type="bold" style={{*/}
                            {/*alignSelf: "center",*/}
                            {/*color: this.state.seconds < 1 ? Colors.blue : Colors.gray,*/}
                            {/*fontSize: moderateScale(14),*/}
                            {/*textAlign: 'center'*/}

                            {/*}}/>*/}
                            {/*<View style={{width: moderateScale(6)}}/>*/}
                            {/*<HMIcon*/}
                            {/*name={"ios-reload"}*/}
                            {/*style={{*/}
                            {/*color: this.state.seconds < 1 ? Colors.blue : Colors.gray,*/}
                            {/*fontSize: moderateScale(16)*/}
                            {/*}}/>*/}
                            {/*</TouchableOpacity>*/}

                            <TouchableOpacity
                                style={{
                                    width: moderateScale(120),
                                    height: moderateScale(40),
                                    alignItems: 'center',
                                    justifyContent: 'center',

                                    backgroundColor: Colors.colorPrimary,
                                    borderRadius: moderateScale(6),


                                }}
                                onPress={() => {
//this.getData()
                                    this.checkCode(this.state.code)
                                }}
                            >
                                <HMTextView
                                    style={{
                                        //fontSize:moderateScale(16)
                                    }}
                                    text={"constant.NextLevel"}
                                    lang
                                    type={"bold"}
                                />
                            </TouchableOpacity>
                        </View>

                        <HMTextView
                            type="bold"
                            style={{

                                color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                fontSize: moderateScale(14),
                                //   textAlign: 'center'

                            }}
                            _children
                                 styleRoot={{
                                     alignSelf: "center",
                                     //flexDirection: 'column',
                                    // flex: 1,
                                     // justifyContent: "flex-end",
                                     //flexWrap: 'wrap',
                                     //    alignItems: 'center', justifyContent: 'center'
                                 }}
                        >
                            درصورتی که
                            <Text style={{
                                color: !checkCallCode ? Colors.red : Colors.colorDark,
                                marginHorizontal: moderateScale(6)
                            }}>
                                کد ورود
                            </Text>
                            را دریافت نکردید از روش های ذیل برای دریافت کد اقدام نمایید :
                        </HMTextView>
                        <View style={{
                            flexDirection: "row",
                            width: "100%",
                            flexWrap: 'wrap',
                            alignItems: "center",
                            justifyContent: "center",
                            // backgroundColor: "#5ad5ee"
                        }}>
                            <TouchableOpacity
                                style={{
                                    flexDirection: 'row-reverse',
                                    alignItems: 'center', justifyContent: 'center',
                                    borderRadius: moderateScale(4),
                                    borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                    padding: moderateScale(4),
                                    borderWidth: moderateScale(1),
                                   // marginTop: moderateScale(4),
                                    marginHorizontal: moderateScale(4),
                                    marginVertical: moderateScale(4),
                                    width: moderateScale(200),
                                    height: moderateScale(60),
                                  //  alignSelf: "center"

                                }}
                                onPress={() => {


                                    let paramss = {
                                        "lang": i18n.locale,
                                        "mobile": this.props.route.params.mobile,
                                        "type": "mobile",
                                        "retry": true,
                                    };


                                    store.dispatch(callWebservice(
                                        null,
                                        // typeExport._baseUrlSatia + "user/sendcode",
                                        typeExport._baseUrlSatia + "user/sendcode",
                                        paramss,
                                        typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                        "POST",
                                        this.state,
                                        this.retryTime
                                    ))

                                }}
                                disabled={checkCallCode}
                            >

                                <HMIcon
                                    type={"MaterialIcons"}
                                    name={"phonelink-ring"}
                                    style={{
                                        color: !checkCallCode ? Colors.blue : Colors.gray,
                                        fontSize: moderateScale(24)
                                    }}/>

                                <View style={{
                                    flex: 1,
                                    flexDirection: "row",
                                    paddingHorizontal: moderateScale(4),
                                    // flexDirection: 'column',
                                    // flex: 1,
                                    // justifyContent: "flex-end",
                                    //   flexWrap: 'wrap',
                                    //    alignItems: 'center', justifyContent: 'center'

                                }}>
                                    <HMTextView
                                        type="bold"
                                        style={{
                                            // alignSelf: "center",
                                            color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                            fontSize: moderateScale(14),
                                            //    textAlign: 'center'

                                        }}
                                        _children
                                        styleRoot={{
                                            flexDirection: 'column',
                                            flex: 1,
                                            // justifyContent: "flex-end",
                                            flexWrap: 'wrap',
                                            //    alignItems: 'center', justifyContent: 'center'
                                        }}
                                    >

                                        تماس با {mobile}
                                    </HMTextView>
                                    {/*<HMTextView
                                    type="bold"
                                    style={{
                                        // alignSelf: "center",
                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                        fontSize: moderateScale(14),
                                        //    textAlign: 'center'

                                    }}
                                    _children
                                    styleRoot={{
                                        flexDirection: 'column',
                                        flex: 1,
                                        // justifyContent: "flex-end",
                                        flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    درصورتی که
                                    <Text style={{
                                        color: !checkCallCode ? Colors.red : Colors.colorDark,
                                        marginHorizontal: moderateScale(6)
                                    }}>
                                        کد ورود
                                    </Text>
                                    را دریافت نکردید کلیک نمایید تا از طریق تماس تلفنی کد برای شما خوانده شود
                                </HMTextView>*/}

                                </View>

                            </TouchableOpacity>
                            {
                                Phone && <TouchableOpacity
                                    style={{
                                        flexDirection: 'row-reverse',
                                        alignItems: 'center', justifyContent: 'center',
                                        borderRadius: moderateScale(4),
                                        borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        marginVertical: moderateScale(4),
                                        width: moderateScale(200),
                                        height: moderateScale(60),
                                        marginHorizontal: moderateScale(4),
                                     //   alignSelf: "center"

                                    }}
                                    onPress={() => {


                                        let paramss = {
                                            "lang": i18n.locale,
                                            "mobile": this.props.route.params.mobile,
                                            "type": "phone",
                                            "retry": true,
                                        };


                                        store.dispatch(callWebservice(
                                            null,
                                            // typeExport._baseUrlSatia + "user/sendcode",
                                            typeExport._baseUrlSatia + "user/sendcode",
                                            paramss,
                                            typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                            "POST",
                                            this.state,
                                            this.retryTime
                                        ))

                                    }}
                                    disabled={checkCallCode}
                                >

                                    <HMIcon
                                        type={"Feather"}
                                        name={"phone-call"}
                                        style={{
                                            color: !checkCallCode ? Colors.blue : Colors.gray,
                                            fontSize: moderateScale(24)
                                        }}/>

                                    <View style={{
                                        flex: 1,
                                        flexDirection: "row",
                                        paddingHorizontal: moderateScale(4),
                                        // flexDirection: 'column',
                                        // flex: 1,
                                        // justifyContent: "flex-end",
                                        //   flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'

                                    }}>
                                        <HMTextView
                                            type="bold"
                                            style={{
                                                // alignSelf: "center",
                                                color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                fontSize: moderateScale(14),
                                                //    textAlign: 'center'

                                            }}
                                            // _children
                                            // styleRoot={{
                                            //     flexDirection: 'column',
                                            //     flex: 1,
                                            //     // justifyContent: "flex-end",
                                            //     flexWrap: 'wrap',
                                            //     //    alignItems: 'center', justifyContent: 'center'
                                            // }}
                                            text={`تماس با `}
                                        >

                                            تماس با {Phone}
                                        </HMTextView>
                                        <HMTextView
                                            type="bold"
                                            style={{
                                                // alignSelf: "center",
                                                color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                fontSize: moderateScale(14),
                                                //    textAlign: 'center'

                                            }}
                                            // _children
                                            // styleRoot={{
                                            //     flexDirection: 'column',
                                            //     flex: 1,
                                            //     // justifyContent: "flex-end",
                                            //     flexWrap: 'wrap',
                                            //     //    alignItems: 'center', justifyContent: 'center'
                                            // }}
                                            text={Phone}
                                        >


                                        </HMTextView>
                                        {/*<HMTextView
                                    type="bold"
                                    style={{
                                        // alignSelf: "center",
                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                        fontSize: moderateScale(14),
                                        //    textAlign: 'center'

                                    }}
                                    _children
                                    styleRoot={{
                                        flexDirection: 'column',
                                        flex: 1,
                                        // justifyContent: "flex-end",
                                        flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    درصورتی که
                                    <Text style={{
                                        color: !checkCallCode ? Colors.red : Colors.colorDark,
                                        marginHorizontal: moderateScale(6)
                                    }}>
                                        کد ورود
                                    </Text>
                                    را دریافت نکردید کلیک نمایید تا از طریق تماس تلفنی کد برای شما خوانده شود
                                </HMTextView>*/}

                                    </View>

                                </TouchableOpacity>
                            }

                            {
                                Email && <TouchableOpacity
                                    style={{
                                        flexDirection: 'row-reverse',
                                        alignItems: 'center', justifyContent: 'center',
                                        borderRadius: moderateScale(4),
                                        borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        marginVertical: moderateScale(4),
                                        width: moderateScale(200),
                                        height: moderateScale(60),
                                        marginHorizontal: moderateScale(4),
                                       // alignSelf: "center"

                                    }}
                                    onPress={() => {


                                        let paramss = {
                                            "lang": i18n.locale,
                                            "mobile": this.props.route.params.mobile,
                                            "type": "email",
                                            "retry": true,
                                        };


                                        store.dispatch(callWebservice(
                                            null,
                                            // typeExport._baseUrlSatia + "user/sendcode",
                                            typeExport._baseUrlSatia + "user/sendcode",
                                            paramss,
                                            typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                            "POST",
                                            this.state,
                                            this.retryTime
                                        ))

                                    }}
                                    disabled={checkCallCode}
                                >

                                    <HMIcon
                                        type={"MaterialCommunityIcons"}
                                        name={"email-outline"}
                                        style={{
                                            color: !checkCallCode ? Colors.blue : Colors.gray,
                                            fontSize: moderateScale(24)
                                        }}/>

                                    <View style={{
                                        flex: 1,
                                        flexDirection: "row",
                                        paddingHorizontal: moderateScale(4),
                                        // flexDirection: 'column',
                                        // flex: 1,
                                        // justifyContent: "flex-end",
                                        //   flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'

                                    }}>
                                        <HMTextView
                                            type="bold"
                                            style={{
                                                // alignSelf: "center",
                                                color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                                fontSize: moderateScale(14),
                                                //    textAlign: 'center'

                                            }}
                                            _children
                                            styleRoot={{
                                                flexDirection: 'column',
                                                flex: 1,
                                                // justifyContent: "flex-end",
                                                flexWrap: 'wrap',
                                                //    alignItems: 'center', justifyContent: 'center'
                                            }}
                                        >

                                            {Email}
                                        </HMTextView>
                                        {/*<HMTextView
                                    type="bold"
                                    style={{
                                        // alignSelf: "center",
                                        color: !checkCallCode ? Colors.blackLight : Colors.colorDark,
                                        fontSize: moderateScale(14),
                                        //    textAlign: 'center'

                                    }}
                                    _children
                                    styleRoot={{
                                        flexDirection: 'column',
                                        flex: 1,
                                        // justifyContent: "flex-end",
                                        flexWrap: 'wrap',
                                        //    alignItems: 'center', justifyContent: 'center'
                                    }}
                                >
                                    درصورتی که
                                    <Text style={{
                                        color: !checkCallCode ? Colors.red : Colors.colorDark,
                                        marginHorizontal: moderateScale(6)
                                    }}>
                                        کد ورود
                                    </Text>
                                    را دریافت نکردید کلیک نمایید تا از طریق تماس تلفنی کد برای شما خوانده شود
                                </HMTextView>*/}

                                    </View>

                                </TouchableOpacity>
                            }
                      {/*      <View style={{
                                flexDirection: 'row-reverse',
                                alignItems: 'center', justifyContent: 'center',
                                //borderRadius: moderateScale(4),
                                // borderColor: !checkCallCode ? Colors.colorPrimary : Colors.gray,
                                padding: moderateScale(4),
                                // borderWidth: moderateScale(1),
                                marginTop: moderateScale(4),
                                width: moderateScale(200),
                                height: moderateScale(60),
                                marginHorizontal: moderateScale(4),
                                alignSelf: "center"

                            }}/>*/}

                        </View>

                    </View>


                    <View
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',

                        }}
                    >
                        <TouchableOpacity
                            activeOpacity={.9}
                            style={{
                                // backgroundColor: Colors.colorPrimary,
                                width: moderateScale(20),
                                height: moderateScale(20),
                                alignSelf: 'center',
                                // alignItems: "center",
                                //justifyContent: "center",
                                marginTop: moderateScale(8),
                                borderRadius: moderateScale(6),
                                //  position: "absolute",
                                //    bottom: 0,
                                // borderRadius:moderateScale(2)
                            }}
                            onPress={() => {
                                if (Platform.OS !== "web") {
                                    let getUniqueId = DeviceInfo.getUniqueId();
                                    if (Clipboard)
                                        Clipboard.setString(getUniqueId)
                                }

                            }}
                        >

                        </TouchableOpacity>
                        <View style={{
                            width: '100%',
                            height: moderateScale(1),
                            backgroundColor: Colors.light43,
                            marginVertical: moderateScale(4)
                        }}/>
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingHorizontal: moderateScale(12),
                                paddingVertical: moderateScale(10),
                            }}
                        >
                            <HMTextView text={"زمان باقی مانده : " + Tools.getTimeStringM(this.state.seconds)}
                                        type="bold"
                                        style={{
                                            alignSelf: "center",
                                            color: Colors.colorDark,
                                            fontSize: moderateScale(14),
                                            textAlign: 'center'

                                        }}/>
                            <View style={{flexDirection: "row"}}>

                                <TouchableOpacity
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginStart: moderateScale(12)
                                    }}
                                    onPress={() => {
                                        let paramss = {
                                            "lang": i18n.locale,
                                            "mobile": this.props.route.params.mobile,
                                            "retry": true,
                                        };


                                        store.dispatch(callWebservice(
                                            null,
                                            // typeExport._baseUrlSatia + "user/sendcode",
                                            typeExport._baseUrlSatia + "user/sendcode",
                                            paramss,
                                            typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen,
                                            "POST",
                                            this.state,
                                            this.retryTime
                                        ))

                                    }}
                                    disabled={this.state.seconds >= 1}
                                >
                                    <HMTextView text={"ارسال مجدد"} type="bold" style={{
                                        alignSelf: "center",
                                        color: this.state.seconds < 1 ? Colors.blue : Colors.gray,
                                        fontSize: moderateScale(14),
                                        textAlign: 'center'

                                    }}/>
                                    <View style={{width: moderateScale(6)}}/>
                                    <HMIcon
                                        name={"ios-reload"}
                                        style={{
                                            color: this.state.seconds < 1 ? Colors.blue : Colors.gray,
                                            fontSize: moderateScale(16)
                                        }}/>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                    {
                        this.props.NoInternetDialog ?
                            <DialogConnectionCustomize
                                onPress={() => this.checkMobile(this.state.mobile)}
                            />
                            :
                            null
                    }

                    {
                        this.props.isLoading || this.props.isLoadingLogin ?
                            <DialogLoadingCustomize/>
                            : null
                    }
                </View>
            </KeyboardAvoidingView>

        );
    }

    onChangeText(name, text) {
        this.setState({[name]: text});
    }
}
